/**
 * Placeholder tools: they reserve a spot (navigation, clearance, favorites) for tools
 * that are not built yet and show a "coming soon" page. When a tool is built, remove
 * its entry here and add a real tool folder with the SAME id, so favorites and
 * clearance settings carry over.
 *
 * Plain data only: imported by both the server and the browser.
 */
export interface PlaceholderDef {
  id: string;
  name: string;
  tagline?: string;
  section: string;
  description: string;
  icon: string;
}

const ac = (id: string, name: string, tagline: string, icon = 'academy'): PlaceholderDef => ({
  id: `academy-${id}`, name, tagline, section: 'academy', icon,
  description: `${name}: ${tagline} training program, courses and resources.`,
});

export const PLACEHOLDERS: PlaceholderDef[] = [
  // Battlegroup: the Orbat is a real tool and unit pages are generated from it (tools/unit).
  // Tactical Support Corps: TSC Requests, Blueprint Tracker and Org Assets are real tools.
  // Academy
  ac('spectre', 'Spectre', 'Fighter Pilot', 'fighter'),
  ac('strix', 'Strix', 'Multi-Crew Pilot', 'ship'),
  ac('sylph', 'Sylph', 'Crew Member', 'citizen'),
  ac('gryphon', 'Gryphon', 'Support Pilot', 'tsc'),
  ac('berserker', 'Berserker', 'Ground Infantry', 'helmet'),
  { id: 'academy-medical', name: 'Medical', section: 'academy', icon: 'medical',
    description: 'Medical training program, courses and resources.' },
  // Management: Management Requests and Analytics are real tools.
];
